import React, { ComponentProps } from 'react';
import { asFetchableBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { DefaultView, OptionalEditView, Views } from '../../types/BlockWithViews';
import { AttributeGroupPropertiesDefaultView } from './views/AttributeGroupPropertiesDefaultView';
import { AttributeGroupPropertiesEditView } from './views/AttributeGroupPropertiesEditView';

type AttributeGroupPropertiesProps = Views<
  DefaultView<AttributeGroupPropertiesDefaultView> & OptionalEditView<AttributeGroupPropertiesEditView>
>;

/**
 * Block that displays and allows editing of attribute group properties
 * (e.g. whether the group should appear in fast selection).
 */
function AttributeGroupProperties({ views, activeView }: AttributeGroupPropertiesProps) {
  if (activeView === 'edit' && views.edit) {
    return <AttributeGroupPropertiesEditView {...views.edit} />;
  }

  return <AttributeGroupPropertiesDefaultView {...views.default} />;
}

export const AttributeGroupPropertiesBlock = asFetchableBlock(
  AttributeGroupProperties,
  BlockType.attributegroupproperties
);
export type AttributeGroupPropertiesBlock = ComponentProps<typeof AttributeGroupPropertiesBlock>;
